// extracted by mini-css-extract-plugin
export var bounce = "_lc-1";
export var generatingText = "_lc-6";
export var lightning = "_lc-4";
export var popup = "_lc-5";
export var progressBar = "_lc-7";
export var progressFill = "_lc-8";
export var progressShimmer = "_lc-9";
export var progressText = "_lc-a";
export var shimmer = "_lc-3";
export var uploadIcon = "_lc-0";
export var uploadingText = "_lc-2";